import _get from 'lodash/get'
import request from '../request'
import { createAuthorization } from '../auth'

export async function getList ({ server, auth, listId }) {
  const res = await request
    .get(`${server}/admin/page-manager/list/${listId}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function getLists ({ server, auth, language }) {
  const res = await request
    .get(`${server}/admin/page-manager/lists?language[]=${language}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function createList ({ auth, server, data }) {
  const res = await request
    .post(`${server}/admin/page-manager/list`)
    .send(data)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function updateList ({ auth, server, data }) {
  const id = _get(data, 'id')
  const res = await request
    .put(`${server}/admin/page-manager/list/${id}`)
    .send(data)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function deleteList ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/admin/page-manager/list/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}
